import { initContract } from '@ts-rest/core';
import { adminEmailContract } from './email.admin.contract';
import { legacyEmailContract } from './email.legacy.contract';

const c = initContract();

export const emailContract = c.router(
  {
    admin: adminEmailContract,
    legacy: legacyEmailContract,
  },
  {
    pathPrefix: '/email',
    strictStatusCodes: true,
  },
);

export * from './email.legacy.contract';
export * from './email.admin.contract';
export * from './models';
